// extracted by mini-css-extract-plugin
module.exports = {"userDetails":"styles_userDetails__1MuhB"};